import type { ThemeVariantMap } from "@/theme/types";

import { cityExpressDarkTheme } from "./cityExpress.dark";

export const cityExpressTheme: ThemeVariantMap = {
  DARK: cityExpressDarkTheme,
} as const;
